import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SlickSlider from "../SlickSlider/SlickSlider";
import MegaprojectsItem from "./MegaprojectsItem";
import MegaprojectsStats from "../MegaprojectsStats/MegaprojectsStats";
import { useLanguage } from "../../context/LanguageContext";
import styles from "./ProjectCategories.module.css";

const Megaprojects = () => {
  const { t } = useLanguage();
  const [showMegaprojects, setShowMegaprojects] = useState(false);

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const project_items = [
    {
      title: t("megaprojects.items.0.title"),
      status: t("megaprojects.items.0.status"),
      statusType: "construction",
      location: t("megaprojects.items.0.location"),
      year: t("megaprojects.items.0.year"),
      description: t("megaprojects.items.0.description"),
      category: t("megaprojects.items.0.category"),
      cost: t("megaprojects.items.0.cost"),
    },
    {
      title: t("megaprojects.items.1.title"),
      status: t("megaprojects.items.1.status"),
      statusType: "progress",
      location: t("megaprojects.items.1.location"),
      year: t("megaprojects.items.1.year"),
      description: t("megaprojects.items.1.description"),
      category: t("megaprojects.items.1.category"),
      cost: t("megaprojects.items.1.cost"),
    },
    {
      title: t("megaprojects.items.2.title"),
      status: t("megaprojects.items.2.status"),
      statusType: "final",
      location: t("megaprojects.items.2.location"),
      year: t("megaprojects.items.2.year"),
      description: t("megaprojects.items.2.description"),
      category: t("megaprojects.items.2.category"),
      cost: t("megaprojects.items.2.cost"),
    },
    {
      title: t("megaprojects.items.3.title"),
      status: t("megaprojects.items.3.status"),
      statusType: "construction",
      location: t("megaprojects.items.3.location"),
      year: t("megaprojects.items.3.year"),
      description: t("megaprojects.items.3.description"),
      category: t("megaprojects.items.3.category"),
      cost: t("megaprojects.items.3.cost"),
    },
    {
      title: t("megaprojects.items.4.title"),
      status: t("megaprojects.items.4.status"),
      statusType: "planning",
      location: t("megaprojects.items.4.location"),
      year: t("megaprojects.items.4.year"),
      description: t("megaprojects.items.4.description"),
      category: t("megaprojects.items.4.category"),
      cost: t("megaprojects.items.4.cost"),
    },
    {
      title: t("megaprojects.items.5.title"),
      status: t("megaprojects.items.5.status"),
      statusType: "concept",
      location: t("megaprojects.items.5.location"),
      year: t("megaprojects.items.5.year"),
      description: t("megaprojects.items.5.description"),
      category: t("megaprojects.items.5.category"),
      cost: t("megaprojects.items.5.cost"),
    },
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    if (!showMegaprojects) return;

    const interval = setInterval(() => {
      setCount((old) => (old == 6 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [showMegaprojects]);

  const toMultiply = 100 / project_items.length;

  return (
    <section id="megaprojects" className="megaprojects-area pb-130">
      <div className="container">
        <div className="section-title text-center mb-50">
          <h2 className="title text-info">{t("navigation.megaprojects")}</h2>
        </div>

        <div className={styles.categories}>
          <button
            type="button"
            className={styles.categoryCard}
            onClick={() => setShowMegaprojects((open) => !open)}
            aria-expanded={showMegaprojects}
            aria-controls="megaprojects-list"
          >
            <h3>{t("megaprojects.title")}</h3>
            <p className={styles.subtitle}>{t("projectCategories.megaprojectsSubtitle")}</p>
            <p className={styles.description}>{t("megaprojects.description")}</p>
          </button>
          <Link to="/mikrobefektetesek" className={styles.categoryCard}>
            <h3>{t("projectCategories.microInvestmentsTitle")}</h3>
            <p className={styles.subtitle}>{t("projectCategories.microInvestmentsSubtitle")}</p>
            <p className={styles.description}>{t("projectCategories.microInvestmentsDescription")}</p>
          </Link>
        </div>

        {showMegaprojects && (
          <div id="megaprojects-list">
            <div className="row megaprojects-active">
              <SlickSlider settings={slickSettings}>
                {project_items.map((item, index) => (
                  <div key={index} className="col-lg-4">
                    <MegaprojectsItem item={item} />
                  </div>
                ))}
              </SlickSlider>
            </div>
            <div
              className="slide-progressbar"
              style={{
                display: "block",
                width: "100%",
                height: "3px",
                borderRadius: "0",
                background: "rgba(255, 255, 255, 0.1)",
                marginTop: "30px"
              }}
            >
              <div
                style={{
                  height: "2px",
                  backgroundImage: "linear-gradient(to right, #00c4f4, #00c4f4)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: `${count * toMultiply}% 100%`,
                  transition: "background-size 0.3s ease"
                }}
                className="slide-filler"
              />
            </div>
          </div>
        )}
      </div>
      
      {showMegaprojects && <MegaprojectsStats />}
    </section>
  );
};

export default Megaprojects;
